module.exports = __webpack_public_path__ + "static/media/icn-group-heart-KO.04a352c2.svg";